import ScorecardAdHeader from './ScorecardAdHeader'
import ScorecardMetricsValues from './ScorecardMetricsValues'
export default Object.assign(
  theme => {
    return {
      gridHeader: {
      }
    }
  },
  {
    ScorecardAdHeader,
    ScorecardMetricsValues
  }
)



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastPremarket/theme/components/scorecard/ScorecardView/ScorecardScroller/ScorecardScrollableColumn/index.js